export const getPlayer = id =>
    new Promise(resolve => {
        const y = document.createElement('script');
        y.src = 'https://www.youtube.com/iframe_api';
        y.async = 'async';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(y, firstScriptTag);
        window.onYouTubeIframeAPIReady = () => {
            // eslint-disable-next-line
            new YT.Player(id, {
                height: '100%',
                width: '100%',
                playerVars: {
                    rel: 0,
                },
                events: {
                    onReady(event) {
                        resolve(event.target);
                    },
                },
            });
        };
    });
